module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eY2l5"))).then(() => module.bundle.root('jnagv'));